import { NumberFormatSettings } from "./number_format_settings";

export default NumberFormatSettings;
